function controlFromSlider(fromSlider, toSlider) {
  const [from, to] = getParsed(fromSlider, toSlider);
  fillSlider(fromSlider, toSlider);
  if (from > to) {
    fromSlider.value = to;
  }
}

function controlToSlider(fromSlider, toSlider) {
  const [from, to] = getParsed(fromSlider, toSlider);
  fillSlider(fromSlider, toSlider);
  setToggleAccessible(toSlider);
  if (from <= to) {
    toSlider.value = to;
  } else {
    toSlider.value = from;
  }
}

function getParsed(currentFrom, currentTo) {
  const from = parseInt(currentFrom.value, 10);
  const to = parseInt(currentTo.value, 10);
  return [from, to];
}

function fillSlider(from, to) {
  const rangeDistance = to.max - to.min;
  const fromPosition = from.value - to.min;
  const toPosition = to.value - to.min;

  const sliderColor = "#ccc";
  const rangeColor = "#000";

  const background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(toPosition / rangeDistance) * 100}%,
      ${sliderColor} ${(toPosition / rangeDistance) * 100}%,
      ${sliderColor} 100%)`;
  from.style.background = background;
  to.style.background = background;
}

function setToggleAccessible(currentTarget) {
  const toSlider = document.querySelector("#toSlider");
  if (Number(currentTarget.value) <= 0) {
    toSlider.style.zIndex = 2;
  } else {
    toSlider.style.zIndex = 0;
  }
}

const bindRangeSliders = () => {
  const fromSlider = document.querySelector("#fromSlider");
  const toSlider = document.querySelector("#toSlider");

  fillSlider(fromSlider, toSlider);
  setToggleAccessible(toSlider);

  fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider);
  toSlider.oninput = () => controlToSlider(fromSlider, toSlider);

  // Closer
  const closeButton = document.querySelector(
    ".price-container .price-header .expand-button"
  );
  closeButton.addEventListener("click", () => {
    document
      .querySelector(".price-container .price-body")
      .classList.toggle("d-none");

    document
      .querySelector(".price-container .price-header .expand-button .plus")
      .classList.toggle("d-none");
    document
      .querySelector(".price-container .price-header .expand-button .minus")
      .classList.toggle("d-none");
  });
};

// Initial binding
bindRangeSliders();

// Re-bind listeners whenever #facets-container changes
const observer = new MutationObserver(() => {
  bindRangeSliders();
});
const facetsContainer = document.querySelector("#facets-container");
observer.observe(facetsContainer, { childList: true, subtree: true });
